<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M23.25,14.25c-0.414,0-0.75-0.336-0.75-0.75V6h-18c0,0.414-0.336,0.75-0.75,0.75S3,6.414,3,6V2.25C3,1.009,4.009,0,5.25,0
		h16.5C22.991,0,24,1.009,24,2.25V13.5C24,13.914,23.664,14.25,23.25,14.25z M22.5,4.5V2.25c0-0.414-0.336-0.75-0.75-0.75H5.25
		C4.836,1.5,4.5,1.836,4.5,2.25V4.5H22.5z"/>
	<path d="M2.25,24C1.009,24,0,22.991,0,21.75V10.5c0-1.241,1.009-2.25,2.25-2.25h16.5c1.241,0,2.25,1.009,2.25,2.25v11.25
		c0,1.241-1.009,2.25-2.25,2.25H2.25z M1.5,21.75c0,0.414,0.336,0.75,0.75,0.75h16.5c0.414,0,0.75-0.336,0.75-0.75v-7.5h-18V21.75z
		 M19.5,12.75V10.5c0-0.414-0.336-0.75-0.75-0.75H2.25c-0.414,0-0.75,0.336-0.75,0.75v2.25H19.5z"/>
	<path d="M3.75,18.75C3.336,18.75,3,18.414,3,18s0.336-0.75,0.75-0.75H6c0.414,0,0.75,0.336,0.75,0.75S6.414,18.75,6,18.75H3.75z"/>
	<path d="M12.38,21c-0.124,0-0.25-0.009-0.376-0.027c-0.694-0.099-1.308-0.463-1.729-1.023c-0.421-0.561-0.598-1.252-0.499-1.946
		c0.099-0.694,0.463-1.308,1.024-1.729c0.457-0.343,1.001-0.524,1.572-0.524c0.542,0,1.065,0.165,1.503,0.47
		c0.442-0.308,0.957-0.471,1.496-0.471c0.125,0,0.251,0.009,0.375,0.027c0.695,0.099,1.309,0.463,1.729,1.023
		c0.421,0.561,0.598,1.253,0.498,1.947c-0.099,0.694-0.462,1.308-1.023,1.729c-0.458,0.343-1.001,0.524-1.573,0.524c0,0,0,0,0,0
		c-0.542,0-1.065-0.165-1.503-0.47C13.433,20.838,12.918,21,12.38,21z M13.875,18.75c0.235,0,0.459,0.112,0.6,0.3
		c0.18,0.241,0.443,0.396,0.741,0.439c0.054,0.008,0.108,0.011,0.162,0.011c0.244,0,0.476-0.078,0.672-0.225
		c0.24-0.18,0.396-0.443,0.439-0.741c0.043-0.298-0.033-0.594-0.213-0.834c-0.18-0.24-0.443-0.396-0.741-0.439
		c-0.054-0.008-0.108-0.012-0.162-0.012c-0.243,0-0.476,0.078-0.671,0.225c-0.086,0.064-0.162,0.14-0.226,0.225
		c-0.14,0.188-0.365,0.3-0.6,0.3c-0.235,0-0.459-0.112-0.6-0.3c-0.18-0.241-0.443-0.396-0.741-0.439
		c-0.054-0.008-0.108-0.012-0.163-0.012c-0.243,0-0.475,0.078-0.672,0.225c-0.24,0.18-0.396,0.443-0.439,0.741
		c-0.043,0.298,0.033,0.594,0.214,0.834c0.18,0.24,0.443,0.396,0.741,0.439c0.054,0.008,0.108,0.011,0.162,0.011
		c0.243,0,0.476-0.078,0.672-0.225c0.085-0.064,0.161-0.14,0.226-0.225C13.416,18.862,13.64,18.75,13.875,18.75z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'credit-card',
    },
    name: {
      type: String,
      required: false,
      default: 'CreditCard',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>